export type BadgeTone = 'amber' | 'blue' | 'emerald' | 'purple' | 'rose' | 'slate';

export const appSurface = {
  page: 'min-h-screen bg-[#f5f3ee] text-slate-950',
  sidebar: 'bg-[#111827] text-white shadow-2xl shadow-slate-950/10',
  mainCanvas: 'bg-[radial-gradient(circle_at_top_left,_rgba(255,255,255,0.9),_rgba(245,243,238,0.92)_42%,_rgba(238,234,226,0.85))]',
  panel: 'rounded-2xl border border-slate-200/80 bg-white/95 shadow-sm shadow-slate-200/80',
  panelHover: 'transition hover:-translate-y-0.5 hover:border-blue-200 hover:shadow-md hover:shadow-slate-200/80',
  metric: 'rounded-2xl border border-slate-200/80 bg-white/95 p-5 shadow-sm shadow-slate-200/70',
  iconBox: 'flex h-11 w-11 items-center justify-center rounded-xl',
  eyebrow: 'text-xs font-semibold uppercase tracking-[0.18em]',
};
